import styled from 'styled-components'
import { spacing } from '~/constants/theme'

// Centered copy column for the interstitial. Vertical rhythm comes from theme
// spacing tokens (matching the Login card) rather than ad-hoc pixel margins.
export const CopyStack = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.spacingMD};
`

/** For muted copy that can wrap; the core `Text` line height is tight. */
export const wrappingCopyStyle = {
  lineHeight: 'var(--chakra-line-heights-moderate)',
}

export const settingsLinkStyle = {
  color: 'var(--chakra-colors-brand-solid)',
  textDecoration: 'underline',
}

export const FallbackStack = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.spacingMD};
`

export const ActionStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.spacingSM};
`
